<template>
  <div v-if="marunage_count > 0" class="ui olive message">
    <ul class="list">
      <li>
        <a href="/shopadmin/candidates?status=false">立候補可能な宴会や会議が{{ marunage_count }}件あります</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            marunage_count: 0
        };
    },
    created: function() {
        this.createForm({limit: 65535}).get('/shopadmin/api/marunages?status=false', function(response) {
            this.marunage_count = response.data.length;
        });
    }
};
</script>
